export default {
  "title": {
    "evolution": "Evolución fatiga",
    "biocompatibilityIndex": "Índice de biocompatibilidad",
    "indicators": "Principales indicadores",
    "workshifts": "Jornadas",
    "alertCurve": "Curva de alerta"
  },
  "help": {
    "workshifts": "Permite visualizar las jornadas registradas en el intervalo de fechas seleccionadas en la parte superior de la pantalla (sólo se mostrará un máximo de 14 días), las jornadas podrían estar compuestas por distintos tipos de actividades descritos en la leyenda de este gráfico.",
    "alertCurve": "Permite visualizar los distintos niveles de alerta, fatiga y somnolencia durante el periodo de fechas seleccionado en la parte superior de la pantalla (sólo se mostrará un máximo de 14 días). A través de este reporte podrás identificar los momentos de exposición a somnolencia y fatiga crítica.",
    "events": "Evento de somnolencia: El conductor muestra indicios de cansancio o somnolencia. Se encuentra en un estado en el que el cansancio tiene un efecto adverso en la capacidad para concentrarse en la tarea de conducción."
  },
  "buttons": {
    "moreDetails": "más detalles",
    "changeView": "cambiar vista"
  },
  "graphToolTip": {
    "indice": "Indice de fatiga",
    "activity": "Actividad",
    "alertLevel": "Nivel de alerta",
    "event": "Evento",
    "hour": "Hora",
    "duration": "Duración",
    "start": "Inicio",
    "end": "Fin",
    "place": "Lugar"
  },
  "graphEventsLabels": {
    "driving": "Conducción",
    "detention": "Detención",
    "base": "Base",
    "client": "Cliente"
  },
  "graphAlertStateLabels": {
    "a1": "Muy despierto",
    "a2": "Despierto",
    "a3": "Normal",
    "a4": "Leve somnolencia",
    "a5": "Somnolencia",
    "a6": "Muy fatigado",
    "a7": "Extremadamente fatigado",
    "aSleep": "Durmiendo",
    "roadWarning": "Somnolencia",
    "sleepPeriods": "Períodos de sueño",
    "featuredSleepPeriods": "Períodos de sueño destacados",
    "day": "DÍA",
    "analysis": "ANÁLISIS",
    "hours": "HORAS",
    "events": "EVENTOS"
  },
  "ibcToolTip": {
    "labelText": "Indicador que permite identificar que tan riesgosa es la estructura de turnos del conductor. Para esto se procesan los horarios de inicio y término de trabajo durante los últimos 14 días y se entrega este índice que oscila entre 0 y 100, siendo 0 no fatigado y 100 extremadamente fatigado.",
    "outOfRisk": "Riesgo bajo",
    "middleRisk": "Riesgo medio",
    "to": "a",
    "higherRisk": "Riesgo alto"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/spanish/fatigue/driverFatigue.js